<template>
    <div id="admin-content">
        <table style="width: 100%">
            <caption class="caption">Admin link list table</caption>
            <tr class="header">
                <th scope="col"></th>
                <th scope="col"></th>
            </tr>
            <tr>
                <td style="vertical-align: top;" class="menu">
                    <router-link to="/admin/userList">{{ $t("views.admin.link.users") }}</router-link>
                    <br/>
                    <router-link to="/admin/planList">Plans</router-link>
                    <br/>
                    <router-link to="/admin/notificationList">{{ $t("views.admin.link.notification") }}</router-link>
                    <br/>
                    <router-link to="/admin/policyList">{{ $t("views.admin.link.policy") }}</router-link>
                    <br/>
                    <a href="#" v-on:click="handoff()">{{ $t("views.admin.link.systemAdmin") }}</a>
                    <br/>
                </td>
                <td style="vertical-align: top;" class="content">
                    <router-view/>
                </td>
            </tr>
        </table>
        <form target="analysisAdmin" v-bind:action="adminUrl" method="post" ref="adminRef">
            <input type="hidden" name="token" v-bind:value="token">
        </form>
    </div>
</template>

<script>

    import { adminService } from '@/services/admin.service'

    export default {
        name: 'Admin',
        data () {
            return {
                adminUrl: '',
                token: ''
            }
        },
        methods: {
            handoff: function (event) {
                if (event) {
                    event.preventDefault()
                }
                adminService.token().then((data) => {
                    window.open('', 'analysisAdmin');
                    this.adminUrl = data.url;
                    this.token = data.token;
                    this.$refs.adminRef.submit();
                }).catch(err => {
                    console.error('Something went wrong: ', err)
                });
            }
        }
    }

</script>

<style lang="scss">
    #admin-content {
        background-color: $surface-alpha;
        height: auto;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 2px rgba(0, 0, 0, 0.1);

        .menu {
            padding-top: 20px;
            width: 200px;
        }

        h1 {
            @extend %type-alpha;
        }

        h2 {
            @extend %type-beta;
        }

        label {
            width: 200px;
            float: left;
            @extend %type-epsilon;
        }

        .datatable {
            border-spacing: 0px;
            width: 100%;
            text-align: left;
        }

        .datatable td {
            padding: 3px;
        }

        .datatable tr:nth-child(even){
            background-color: #ddddff;
        }
        .datatable tr:nth-child(odd){
            background-color: #eeeeff;
        }
        .datatable th{
            background-color: #6666ff;
            color: #ffffff
        }

        select,
        input {
            width: auto;
            height: auto;
            background-color: $surface-alpha;
            border: 1px solid $border-alpha;
            border-radius: 5px;
            padding: 0 15px;
            margin-bottom: 8px;

            &.error {
                border-color: $text-error;
            }
        }

        input.submit {
            font-size: 12pt;
            font-weight: $semi-bold;
            margin-top: 10px;
            background-color: #ddddff;
            border: none;
            border-radius: 5px;

            &:hover {
                cursor: pointer;
            }
        }

        input#meter {
            border: none;
            outline: none;
            background: $surface-beta;
            padding: 0;
        }

        .recovery {
            @extend %type-omega;
            float: right;
        }

        .help {
            @extend %type-legal;
            margin: -20px 0 20px;
        }

        .caption {
            display: none;
        }
    }
</style>
